import { useState } from 'react';

import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import Question from '@/shared-components/accordeons/components/Question';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import PublicSuccessCheck from '@/shared-components/icons/components/public/PublicSuccessCheck';
import Text from '@/shared-components/text/components/Text';

import './styles/LimitedEditionForm.css';

export default function LimitedEditionForm({ onRequest, loading, requested, approved = false }) {
  const t = useTranslations('common.forms.add_artwork');
  const [policiesAccepted, setPoliciesAccepted] = useState(requested);

  function requestLimitedEditions() {
    if(!policiesAccepted) {
      alert(t('limited_editions.popup.accept_policies_error'));
    } else {
      if(onRequest) onRequest();
    }
  }

  return (
    <>
      <div className="limited-edition-artwork-form__policies-container">
        <div className={`limited-edition-artwork-form__policies-checkbox${(loading || requested ) ? " read-only" : ""}`} onClick={() => setPoliciesAccepted(!policiesAccepted)}>
          {policiesAccepted && <PublicSuccessCheck className="limited-edition-artwork-form__policies-checkbox-check" />}
        </div>

        <Text
          className="limited-edition-artwork-form__policies-text"
          paragraph>
          {t('limited_editions.popup.policy_prefix')}{' '}<a href="/limited-edition-policies" target="_blank" rel='noreferrer' aria-label={t('limited_editions.popup.policies_aria_label')}>
            {t('limited_editions.popup.policies_label')}</a>.
        </Text>
      </div>
      {
        requested || approved ?
          <Text
            className="limited-edition-artwork-form__requested element-non-selectable">
            {approved ? t('limited_editions.popup.available') : t('limited_editions.popup.requested')}
          </Text>

          :
          <ContinueButton 
            className="limited-edition-artwork-form__request-button"
            loading={loading} 
            link 
            onClick={requestLimitedEditions}
          >
            {t('limited_editions.popup.request')}
          </ContinueButton>
      }
      {
        config.faqs.limited_editions.map((question, index) => (
          <Question 
            className="limited-edition-artwork-form__question" 
            key={index} 
            question={question.question} 
            answer={question.answer} 
            heightClassName={index !== 0 ? "limited-edition-artwork-question-height" : "limited-edition-artwork-question-height-first"}
          />
        ))
      }
    </>
  );
}
